import { configureStore } from "@reduxjs/toolkit";
import contactsSlice from "./slices/contactsSlice";
import campaignsSlice from "./slices/campaignsSlice";
import formsSlice from "./slices/formsSlice";
import organizationSlice from "./slices/organizationSlice";
import sequencesSlice from "./slices/sequencesSlice";

export default configureStore({
  reducer: {
    contacts: contactsSlice,
    campaigns: campaignsSlice,
    forms: formsSlice,
    organization: organizationSlice,
    sequences: sequencesSlice,
  },
});
